import React from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";
import { useSelector } from "react-redux";

import { UIAvatar, UIFormSectionCard } from "../../../ui";
import messages from "../../../../assets/locale/messages";

const EvaluationApplicantCard = ({ applicant, children }) => {
  const lang = useSelector((state) => state.locale.lang);
  const t = messages[lang].events.viewEvents.evaluationsTab.applicantsView.evaluateForm;

  return (
    <UIFormSectionCard title={t.applicantDetails}>
      <Box className="eval-applicant-form__applicant-info">
        <UIAvatar
          name={applicant.applicantName}
          image={applicant.applicantImage}
          size="lg"
        />
        <Box className="eval-applicant-form__detail-group">
          <Typography className="eval-applicant-form__detail-label">{t.staffName}</Typography>
          <Typography className="eval-applicant-form__detail-value">{applicant.applicantName}</Typography>
        </Box>
        <Box className="eval-applicant-form__detail-group">
          <Typography className="eval-applicant-form__detail-label">{t.role}</Typography>
          <Typography className="eval-applicant-form__detail-value">{applicant.role}</Typography>
        </Box>
        <Box className="eval-applicant-form__detail-group">
          <Typography className="eval-applicant-form__detail-label">{t.assignedZone}</Typography>
          <Typography className="eval-applicant-form__detail-value">{applicant.zoneName}</Typography>
        </Box>
      </Box>
      {children}
    </UIFormSectionCard>
  );
};

EvaluationApplicantCard.propTypes = {
  applicant: PropTypes.shape({
    applicantName: PropTypes.string.isRequired,
    applicantImage: PropTypes.string,
    role: PropTypes.string.isRequired,
    zoneName: PropTypes.string.isRequired,
  }).isRequired,
  children: PropTypes.node,
};

EvaluationApplicantCard.defaultProps = {
  children: null,
};

export default EvaluationApplicantCard;
